<template>
  <div class="mb-4">
    <p class="text-sm font-semibold mb-2">{{ $t("visibility") }}</p>
    <div class="flex flex-col gap-2">
      <div
        v-for="option in privacyOptions"
        :key="option.value"
        class="flex items-center gap-3 p-3 border rounded-lg cursor-pointer duration-200"
        :class="
          selectedValue === option.value
            ? 'border-primary bg-primary/5'
            : 'border-surface-300 dark:border-surface-700 hover:border-primary/50'
        "
        role="button"
        @click="emit('update:modelValue', option.value)"
      >
        <i
          :class="[
            option.icon,
            selectedValue === option.value ? 'text-primary' : 'text-surface-500',
          ]"
          class="text-base"
        />
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium leading-tight">{{ option.label }}</p>
          <p class="text-xs text-surface-500 dark:text-surface-400 mt-0.5">
            {{ option.description }}
          </p>
        </div>
        <i
          v-if="selectedValue === option.value"
          class="pi pi-check-circle text-primary"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TikTokPrivacyLevel } from "@/types/contentCalendar";

const props = defineProps<{
  modelValue?: TikTokPrivacyLevel;
}>();

const selectedValue = computed(() => props.modelValue ?? "SELF_ONLY");

const emit = defineEmits<{
  "update:modelValue": [value: TikTokPrivacyLevel];
}>();

const privacyOptions: {
  value: TikTokPrivacyLevel;
  label: string;
  description: string;
  icon: string;
}[] = [
  {
    value: "PUBLIC_TO_EVERYONE",
    label: "Public",
    description: "Anyone on TikTok can see this post",
    icon: "pi pi-globe",
  },
  {
    value: "MUTUAL_FOLLOW_FRIENDS",
    label: "Friends",
    description: "Only mutual followers can see this post",
    icon: "pi pi-users",
  },
  {
    value: "FOLLOWER_OF_CREATOR",
    label: "Followers",
    description: "Only your followers can see this post",
    icon: "pi pi-user",
  },
  {
    value: "SELF_ONLY",
    label: "Private",
    description: "Only you can see this post",
    icon: "pi pi-lock",
  },
];
</script>
